var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 27,
    viewBox: "0 0 38 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2422 17.1016H21.7416C21.2794 17.1016 20.9043 17.4208 20.9043 17.8142C20.9043 18.2076 21.2793 18.5269 21.7416 18.5269H30.2422C30.7043 18.5269 31.0794 18.2076 31.0794 17.8142C31.0794 17.4208 30.7049 17.1016 30.2422 17.1016",
    fill: "#106C3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.69922 18.8174C5.85499 17.7322 6.35631 16.7617 7.09638 16.0202C7.99661 15.1207 9.23229 14.5669 10.6058 14.5664C11.9783 14.5669 13.2149 15.1208 14.1152 16.0202C14.8558 16.7618 15.3556 17.7322 15.5114 18.8174H5.69922ZM8.8795 8.97672C9.32321 8.53353 9.92898 8.26223 10.6054 8.26172C11.2819 8.26223 11.8867 8.53345 12.3313 8.97672C12.7742 9.42086 13.0458 10.0262 13.0458 10.7022C13.0458 11.3787 12.7741 11.984 12.3313 12.4281C11.8867 12.8709 11.2819 13.1425 10.6054 13.1431C9.92891 13.1422 9.32321 12.8704 8.8795 12.4281C8.4358 11.984 8.16502 11.3786 8.16406 10.7022C8.16502 10.0262 8.4358 9.42094 8.8795 8.97672V8.97672ZM13.1024 13.65C13.9386 12.9406 14.471 11.884 14.471 10.7016C14.471 8.56663 12.7403 6.83638 10.6053 6.83594C8.46941 6.83638 6.7396 8.56663 6.73865 10.7016C6.73865 11.884 7.27127 12.9406 8.10729 13.65C5.82023 14.6225 4.2168 16.8886 4.2168 19.531C4.2168 19.7186 4.29274 19.9019 4.42534 20.0351C4.55795 20.1681 4.74172 20.2436 4.92945 20.2436H16.2815C16.4691 20.2436 16.6525 20.1677 16.7856 20.0351C16.9185 19.9025 16.9941 19.7187 16.9941 19.531C16.9932 16.8886 15.3898 14.6224 13.1024 13.65V13.65Z",
    fill: "#106C3A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7882 12.8281H21.7416C21.2795 12.8281 20.9043 13.1474 20.9043 13.5408C20.9043 13.9342 21.2794 14.2534 21.7416 14.2534H31.7882C32.2504 14.2534 32.6255 13.9342 32.6255 13.5408C32.6255 13.1474 32.2504 12.8281 31.7882 12.8281",
    fill: "#106C3A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9043 9.26343C20.9043 9.65685 21.2793 9.97609 21.7416 9.97609H31.7882C32.2503 9.97609 32.6254 9.65685 32.6254 9.26343C32.6254 8.87002 32.2503 8.55078 31.7882 8.55078H21.7416C21.2794 8.55078 20.9043 8.87002 20.9043 9.26343",
    fill: "#106C3A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1067 24.7046H36.1066C36.1066 24.962 35.8886 25.1796 35.6316 25.1796H1.90086C1.64298 25.1796 1.42578 24.962 1.42578 24.7046V1.90086C1.42578 1.64342 1.64283 1.42578 1.90086 1.42578H24.4105H27.9291H35.6317C35.8886 1.42578 36.1067 1.64342 36.1067 1.90086V24.7046ZM35.631 0H27.9285H24.41H1.90031C0.854788 0 0 0.855155 0 1.90038V24.7041C0 25.7493 0.854788 26.6044 1.90031 26.6044H35.631C36.6757 26.6044 37.5312 25.7493 37.5312 24.7041V1.90038C37.5312 0.855155 36.6757 0 35.631 0V0Z",
    fill: "#106C3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgId);
export default __webpack_public_path__ + "static/media/id.8ee249cdfda0774b1aa732ac1cf00a59.svg";
export { ForwardRef as ReactComponent };